/* eslint-disable */
import cn from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { shareBuilding } from 'actions/collections';
import { setPopUp } from 'actions/environment';
import iconShare from 'assets/images/icons/icon-share.svg';
import ShareDialog from 'components/ShareDialog';

import styles from './ShareButton.scss';

class ShareButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      shareId: null,
    };
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  render() {
    const { className, pure, href = '#', tooltip, building, objectType, profile } = this.props;
    const { modalIsOpen, shareId } = this.state;

    return (
      <div
        className={cn(styles.PrintWrap, className, { [styles.Pure]: pure })}
        data-tip={tooltip}
        data-for="global"
      >
        <a
          className={styles.ButtonPrint}
          href={href}
          target="_blank"
          onClick={this.handleClick.bind(this)}
        >
          <img src={iconShare} alt="" />
        </a>
        {modalIsOpen ? (
          <ShareDialog
            building={building}
            shareId={shareId}
            onClose={this.handleModalClose}
            objectType={objectType}
            profile={profile}
          />
        ) : null}
      </div>
    );
  }

  handleClick = (e) => {
    e.preventDefault();

    const { shareBuilding, building, onClick } = this.props;

    if (onClick) {
      onClick();
    }

    shareBuilding({ buildingId: building.data.id }).then((res) => {
      this.setState({
        modalIsOpen: true,
        shareId: res.data.data.selectionReferal,
      });
    });
  };

  handleModalClose = () => {
    this.setState({
      modalIsOpen: false,
      shareId: null,
    });
  };
}

export default connect(null, {
  setPopUp,
  shareBuilding,
})(ShareButton);



// WEBPACK FOOTER //
// ./src/components/ShareButton/ShareButton.js